import { render, staticRenderFns } from "./createOfferGoal.vue?vue&type=template&id=162a1db7&"
import script from "./createOfferGoal.vue?vue&type=script&lang=ts&"
export * from "./createOfferGoal.vue?vue&type=script&lang=ts&"
import style0 from "./createOfferGoal.vue?vue&type=style&index=0&id=162a1db7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports